import { render, staticRenderFns } from "./Financial.vue?vue&type=template&id=228e089e&"
import script from "./Financial.vue?vue&type=script&lang=ts&"
export * from "./Financial.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports